import { useState } from "react";

export const CompanyLogoImage = ({
  companyName,
  logoUrl,
  smallLogoUrl,
  className = "h-full w-full object-contain",
  fallback,
}: {
  companyName: string;
  logoUrl?: string | null;
  smallLogoUrl?: string | null;
  className?: string;
  fallback?: React.ReactNode;
}) => {
  /* React Hooks */
  const [failedUrls, setFailedUrls] = useState<string[]>([]);

  /* Render */
  const render = () => {
    const url = [smallLogoUrl, logoUrl].find(
      (candidate) => candidate && !failedUrls.includes(candidate),
    );
    if (!url) return fallback;
    return (
      <img
        alt={`${companyName} logo`}
        className={className}
        src={url}
        onError={() => {
          setFailedUrls((failed) => [...failed, url]);
        }}
      />
    );
  };

  return render();
};
